import { usePortalLabel } from '../usePortalLabel';
import { useFeatureEnabled } from './useFeatureEnabled';

function useFeatureDuplicateReservationMemberPortal(): boolean {
  return useFeatureEnabled('DUPLICATE_RESERVATION_MP');
}

function useFeatureDuplicateReservationClientPortal(): boolean {
  return useFeatureEnabled('DUPLICATE_RESERVATION_CP');
}

function useFeatureDuplicateReservationF1(): boolean {
  return useFeatureEnabled('DUPLICATE_RESERVATION_F1');
}

function useFeatureDuplicateReservationForCurrentPortal(): boolean {
  const f1 = useFeatureDuplicateReservationF1();
  const member = useFeatureDuplicateReservationMemberPortal();
  const client = useFeatureDuplicateReservationClientPortal();
  const label = usePortalLabel();
  if (label === 'client-portal') return client;
  if (label === 'member-portal') return member;
  return f1;
}

export {
  useFeatureDuplicateReservationMemberPortal,
  useFeatureDuplicateReservationClientPortal,
  useFeatureDuplicateReservationF1,
  useFeatureDuplicateReservationForCurrentPortal,
};
